import { RequestDocumentTypes } from 'src/app/product-capture/model/consts/document-modal.consts';
import { DocumentType } from 'src/app/product-capture/model/consts/document-type.const';
import { LANGUAGE } from 'src/app/product-capture/model/enums/language.enum';
import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';

export enum ClientDomain {
  DeutscheBank = 'db.inspire.direct',
  Demo = 'o3.inspire.direct',
}

export type DocumentLanguages = {
  [key in DocumentType]?: LANGUAGE[];
};

export type ProductDocumentLanguages = {
  [key in ProductTypeEnum | 'all']?: DocumentLanguages;
};

export type ClientDocuments = {
  [key in ClientDomain]?: ProductDocumentLanguages;
};

export const ClientProductDocumentLanguages: ClientDocuments = {
  [ClientDomain.DeutscheBank]: {
    [ProductTypeEnum.CLN]: {
      [DocumentType.KID]: [LANGUAGE.EN, LANGUAGE.DE, LANGUAGE.IT, LANGUAGE.FR],
      [DocumentType.FINAL_TERMS]: [LANGUAGE.EN, LANGUAGE.IT],
    },
    all: {
      [DocumentType.FINAL_TERMS]: [
        LANGUAGE.EN,
        LANGUAGE.FR,
        LANGUAGE.NL,
        LANGUAGE.DE,
        LANGUAGE.IT,
        LANGUAGE.ES,
      ],
    },
  },
  [ClientDomain.Demo]: {
    all: {
      [DocumentType.OTHER]: [
        LANGUAGE.EN,
        LANGUAGE.FR,
        LANGUAGE.NL,
        LANGUAGE.DE,
        LANGUAGE.IT,
        LANGUAGE.ES,
      ],
      [DocumentType.KID]: [
        LANGUAGE.EN,
        LANGUAGE.FR,
        LANGUAGE.NL,
        LANGUAGE.DE,
        LANGUAGE.IT,
        LANGUAGE.ES,
      ],
      [DocumentType.TERM_SHEET]: [
        LANGUAGE.EN,
        LANGUAGE.FR,
        LANGUAGE.NL,
        LANGUAGE.DE,
        LANGUAGE.IT,
        LANGUAGE.ES,
      ],
      [DocumentType.FINAL_TERMS]: [
        LANGUAGE.EN,
        LANGUAGE.FR,
        LANGUAGE.NL,
        LANGUAGE.DE,
        LANGUAGE.IT,
        LANGUAGE.ES,
      ]
    },
  },
};

export const GenericProductTypeDocumentLanguages: any = {
  [ProductTypeEnum.FIXED_RATE_NOTE]: {
    [DocumentType.OTHER]: {
      [RequestDocumentTypes.COVER_LETTER_CBF]: [LANGUAGE.EN, LANGUAGE.DE],
      [RequestDocumentTypes.COVER_LETTER_CBL]: [LANGUAGE.EN],
      [RequestDocumentTypes.GLOBAL_NOTE]: [LANGUAGE.EN],
      [RequestDocumentTypes.PIB]: [LANGUAGE.EN, LANGUAGE.DE],
    },
  },
  [ProductTypeEnum.FLOATING_RATE_NOTE]: {
    [DocumentType.OTHER]: {
      [RequestDocumentTypes.COVER_LETTER_CBF]: [LANGUAGE.EN, LANGUAGE.DE],
      [RequestDocumentTypes.COVER_LETTER_CBL]: [LANGUAGE.EN],
      [RequestDocumentTypes.GLOBAL_NOTE]: [LANGUAGE.EN],
    },
  },
  [ProductTypeEnum.FIXED_TO_FLOATING_FLOATING_TO_FIXED_RATE_NOTE]: {
    [DocumentType.OTHER]: {
      [RequestDocumentTypes.COVER_LETTER_CBF]: [LANGUAGE.EN, LANGUAGE.DE],
      [RequestDocumentTypes.COVER_LETTER_CBL]: [LANGUAGE.EN],
      [RequestDocumentTypes.GLOBAL_NOTE]: [LANGUAGE.EN],
    },
  },
};
